import { FC } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { comparisonChipColors } from './comparison.types.ts';

const legendItems = (t: (k: string) => string) => [
  { color: comparisonChipColors.ordered, label: t('order.comparison_ordered') },
  { color: comparisonChipColors.sold, label: t('order.comparison_sold') },
  { color: comparisonChipColors.returned, label: t('order.comparison_returned') },
];

export const ComparisonFooterLegend: FC = () => {
  const { t } = useTranslation();
  return (
    <SLegendBox>
      {legendItems(t).map((item) => (
        <Stack key={item.label} direction='row' alignItems='center' spacing={0.5}>
          <SDot sx={{ backgroundColor: item.color }} />
          <Typography variant='caption' noWrap sx={{ lineHeight: 1.3 }}>
            {item.label}
          </Typography>
        </Stack>
      ))}
    </SLegendBox>
  );
};

const SLegendBox = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  alignContent: 'center',
  gap: '1px 10px',
  width: '100%',
  height: '100%',
  padding: '0 8px',
}));

const SDot = styled(Box)(({ theme }) => ({
  width: 10,
  height: 10,
  borderRadius: '50%',
  flexShrink: 0,
  border: `1px solid ${theme.palette.divider}`,
}));
